export default __webpack_public_path__ + "static/media/cssda-ui-Ronnie-Feng.a4a743dd.webp";